export default __webpack_public_path__ + "static/media/world.a024a9df.png";